module.exports = __webpack_public_path__ + "static/media/bnb.991ae911.svg";